import { Component, OnDestroy, ViewChild } from '@angular/core';

import { Platform, ModalController, NavController, IonMenu } from '@ionic/angular';
import { RemoteDataService } from './services/remote-data.service';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { EmailItineraryService } from './services/email-itinerary.service';
import { ManageBookingsUtils} from '@app/utils/manageBookingsUtils';
import { FCMService } from '@app/services/fcm.service';
import { StorageService } from '@app/services/storage.service';
import { CommonHelperService } from './services/common-helper.service';
import { environment } from '@env/environment';
import { Capacitor } from '@capacitor/core';
import { NetworkService } from './services/network.service';
import { Device } from '@capacitor/device';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnDestroy {
  navigate = [
    {
      title: 'About',
      url: '/tabs/about',
      icon: 'information-circle-outline'
    },
    {
      title: 'Privacy',
      url: '/tabs/privacy',
      icon: 'briefcase-outline'
    },
    {
      title: 'Licenses',
      url: '/tabs/licenses',
      icon: 'newspaper-outline'
    },
    {
      title: 'FAQ',
      url: '/tabs/faq',
      icon: 'help-circle-outline'
    },
  ];
  unsubscribe$: Subject<void> = new Subject<void>();
  @ViewChild('menu') menu: IonMenu;
  isDevice = false;
  darkThemeEnable = false;
  currentDevice;
  constructor(
    private platform: Platform,
    public remoteDataService: RemoteDataService,
    private modalController: ModalController,
    private router: Router,
    private navController: NavController,
    private mailService: EmailItineraryService,
    private fcmService: FCMService,
    private manageBookingsUtils: ManageBookingsUtils,
    private storageService: StorageService,
    private commonHelper: CommonHelperService,
    private networkService: NetworkService,
  ) {
    this.initializeApp();
  }

  ngOnDestroy() {
    this.platform.backButton.unsubscribe();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      const device = await Device.getInfo();
      if (device) {
        const safeAreaTop = device.platform === 'ios' ? '50px' : '10px';
        document.documentElement.style.setProperty('--custom-safe-area-top', safeAreaTop);
      }
      // initial theme detection
      if (Capacitor.isNativePlatform()) {
        this.setupBackButton();
      }
      await this.networkService.initializeNetworkEvents();
      await this.getCurrentDevice();
    });
  }

  async logOut() {
    await this.commonHelper.stopLoadingIndicator();
    await this.storageService.logout();
  }

  /**
   * ionic hardware button handler only on android
   * this function take priority, and callback
   * higher priority will execution first
   * and cancel lowest priority
   */
  setupBackButton() {
    this.platform.backButton.subscribeWithPriority(5, async (processNextHandler) => {
      /**
       * if modal exist close modal
       * when back button pressed
       */
      const modalInternTel = document.querySelector('.iti__country-list');
      if (modalInternTel) {
        modalInternTel.classList.add('iti__hide');
      } else {
        const modal = await this.modalController.getTop();
        if (modal) {
          modal.dismiss();
        }
        processNextHandler();
      }
    });
    /**
     * if user in tab-home or signup when user press back button should close the app
     * otherwise back to last router
     * there's clean solution for this problem using ionRouterOutlet
     * but there's issue method isAllowback() and couldn't find the solution due it's new fueture in ionic
     */
    this.platform.backButton.subscribeWithPriority(-1, async () => {
      if (this.router.url === '/tabs/tab-home' || this.router.url === '/signup') {
        // tslint:disable-next-line: no-string-literal
        navigator['app'].exitApp();
      } else {
        this.navController.back();
      }
    });
  }

  /**
   * check if user still has access
   */
  async getCurrentDevice() {
    this.currentDevice = await this.storageService.getDevice();
    if (this.currentDevice) {
      const { deviceDetail, ENV, securityPin, mobileNumber } = this.currentDevice;
      if (environment.useAuth0) {
        await this.storageService.getLocal('accessToken');
        await this.storageService.getLocal('refreshToken');
      }

      this.remoteDataService.getLinkedAccounts(securityPin, mobileNumber, deviceDetail.uuid).subscribe(async val => {
        // initialize fcm token if user able to login
        if (Capacitor.isNativePlatform()) {
          await this.fcmService.initializeFCM();
        }
        await this.storageService.setLocal(val?.linkedAccount, 'linkedAccount');
        this.manageBookingsUtils.getSiteInfoAndShiftStatus(mobileNumber, securityPin, deviceDetail, ENV);
        this.getProvider();
      });
    } else {
      await this.commonHelper.stopLoadingIndicator();
      this.storageService.logout();
    }
  }

  /**
   * get provider if user pull refresh refresh provider from api
   * @param event pull event
   */
  getProvider(event?) {
    this.mailService.getProviders(this.currentDevice?.mobileNumber, this.currentDevice?.deviceDetail.uuid, this.currentDevice?.securityPin).subscribe(prov => {
      const providers = prov.filter(p => p.enabled);
      this.storageService.providers.next(providers);
      if (event) { event.target.complete(); }
    });
  }

}
